import { Box, Button, Card, InputAdornment, TextField, Typography } from '@mui/material';
import React from 'react';
import { useForm } from 'react-hook-form';
import { firestore } from '../../../../../contexts/FirebaseContext';
import useAuthUsers from '../../../../../hooks/useAuthUsers';
import { LoadingButton } from '@mui/lab';

function UtilidadesForm({ service, title, dataUser }) {
  const { currentUser } = useAuthUsers();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset
  } = useForm({
    defaultValues: {
      value: dataUser?.userUtility?.[service] || ''
    }
  });

  const onSubmit = async (dataForm) => {
    console.log(dataForm);
    const prevUserUtility = dataUser?.userUtility ? dataUser?.userUtility : {};

    await firestore
      .collection('users')
      .doc(dataUser.id)
      .update({
        userUtility: {
          ...prevUserUtility,
          [service]: Number(dataForm.value)
        }
      });

    const obj = {
      date: new Date(),
      userCreator: currentUser.id,
      userId: dataUser.id,
      prevValue: dataUser?.userUtility?.[service] || null,
      value: Number(dataForm.value),
      service
    };

    await firestore.collection('historial_utilidades_user').add(obj);
  };

  return (
    <Card
      component="form"
      onSubmit={handleSubmit(onSubmit)}
      sx={{ my: '10px', padding: '15px', display: 'flex', gap: '20px', alignItems: 'center' }}
    >
      <Typography fontSize="18px" variant="subtitle2" sx={{ flexGrow: 1 }}>
        {title}
      </Typography>
      <Box sx={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
        <TextField
          type="number"
          error={!!errors.value}
          {...register('value', { required: true })}
          InputProps={{
            endAdornment: <InputAdornment position="end">%</InputAdornment>
          }}
          label="Utilidad"
        />

        <LoadingButton loading={isSubmitting} type="submit" variant="contained" size="large">
          Guardar
        </LoadingButton>
      </Box>
    </Card>
  );
}

export default UtilidadesForm;
